import { useTranslation } from 'react-i18next';
import { Can } from 'components/Can';
import { SubmitProjectProposalViewList } from 'features/SubmitProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function SubmitProjectProposalViewListPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="project">
            <SubmitProjectProposalViewList />
          </Can>
          <Can not do="read" on="project">
            <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default SubmitProjectProposalViewListPage;
